import { render, staticRenderFns } from "./ElemQueue.vue?vue&type=template&id=314cdde8&scoped=true"
import script from "./ElemQueue.vue?vue&type=script&lang=js"
export * from "./ElemQueue.vue?vue&type=script&lang=js"
import style0 from "./ElemQueue.vue?vue&type=style&index=0&id=314cdde8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314cdde8",
  null
  
)

export default component.exports